// Shared content + image assets for LuxeBond Epoxy Services

export const CONTACT = {
  email: "Luxebondresinco@gmail.com",
  phone: "(918) 940-0225",
  phoneHref: "tel:+19189400225",
  region: "Serving Tulsa & surrounding region",
  visualizer: "https://torginol.com/design",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1768315168347-2d700f567893?crop=entropy&cs=srgb&fm=jpg&q=85&w=2200&ixlib=rb-4.1.0",
  metallic: "https://customer-assets-jt897jd0.emergentagent.net/job_luxe-epoxy-preview/artifacts/dtlq978i_metalic%20epoxy%20floor.jfif",
  flake: "https://customer-assets-jt897jd0.emergentagent.net/job_luxe-epoxy-preview/artifacts/iyklxaul_flake%20floor.jfif",
  quartz: "https://customer-assets-jt897jd0.emergentagent.net/job_luxe-epoxy-preview/artifacts/iy7qv72z_quartz%20floor.jfif",
  solid: "https://images.unsplash.com/photo-1772305336606-989a457ffbae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&ixlib=rb-4.1.0",
  garage: "https://images.unsplash.com/photo-1692863211157-9013e04784af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&ixlib=rb-4.1.0",
  showroom: "https://images.unsplash.com/photo-1691706265981-91eb19c19b5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&ixlib=rb-4.1.0",
  kitchen: "https://images.pexels.com/photos/7045351/pexels-photo-7045351.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  warehouse: "https://images.unsplash.com/photo-1771531072574-af6ed6b954c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&ixlib=rb-4.1.0",
};

export const STATS = [
  { num: "15+", suffix: "yrs", label: "Bond durability" },
  { num: "24–72", suffix: "hr", label: "Cure & walk-on time" },
  { num: "Zero", suffix: "seam", label: "Monolithic finish" },
];

export const TRUST = [
  "Licensed & Insured Installers",
  "10-Year Written Warranty",
  "Industrial-Grade Resin Systems",
  "24–72 hr Cure & Walk-On Time",
  "Custom-Mixed On Site",
  "Zero-Downtime Installs",
];

export const SERVICES = [
  {
    idx: "01",
    tag: "Residential",
    title: "Garage Floors",
    body: "Chemical, oil, and hot-tire resistant systems that turn a parking slab into a showroom floor.",
  },
  {
    idx: "02",
    tag: "Residential",
    title: "Home & Living Spaces",
    body: "Seamless basements, sunrooms, and entryways in finishes that read as stone, not epoxy.",
  },
  {
    idx: "03",
    tag: "Surfaces",
    title: "Countertops",
    body: "Heat- and stain-resistant epoxy surfacing for kitchens, bars, and bathrooms — poured, not laminated.",
  },
  {
    idx: "04",
    tag: "Commercial",
    title: "Industrial Facilities",
    body: "Heavy-load, chemical-resistant flooring built for warehouses, plants, and production lines.",
  },
];

export const FINISHES = [
  {
    id: "flake",
    num: "01",
    name: "Flake System",
    dot: "linear-gradient(135deg,#948d7d,#5c584d)",
    kicker: "Broadcast vinyl chip",
    title: "Flake System",
    image: IMG.flake,
    body: "Full-broadcast vinyl flakes locked under a clear topcoat. Hides imperfections, adds slip resistance, and delivers a terrazzo-like depth built for daily abuse.",
    specs: [
      ["Thickness", "18–22 mil"],
      ["Cure to walk", "24 hr"],
      ["Best for", "Garages · Gyms"],
    ],
    tags: ["Slip resistant", "High traffic", "Custom blends"],
  },
  {
    id: "metallic",
    num: "02",
    name: "Metallic Pour",
    dot: "linear-gradient(135deg,#e8c877,#a9603a)",
    kicker: "Reflective 3D pigment",
    title: "Metallic Pour",
    image: IMG.metallic,
    body: "Metallic pigments suspended in clear resin, worked live to create molten, three-dimensional movement. No two floors are ever identical — each one is a single poured artwork.",
    specs: [
      ["Thickness", "30–40 mil"],
      ["Cure to walk", "24–36 hr"],
      ["Best for", "Showrooms · Living"],
    ],
    tags: ["One of a kind", "High gloss", "Seamless"],
  },
  {
    id: "quartz",
    num: "03",
    name: "Quartz Broadcast",
    dot: "linear-gradient(135deg,#efe6d3,#948d7d)",
    kicker: "Double-broadcast quartz",
    title: "Quartz Broadcast",
    image: IMG.quartz,
    body: "Colored quartz aggregate broadcast into resin for a dense, sanitary, and impact-hardened surface. The go-to system where hygiene and toughness both matter.",
    specs: [
      ["Thickness", "1/8–1/4 in"],
      ["Cure to walk", "24 hr"],
      ["Best for", "Kitchens · Labs"],
    ],
    tags: ["Sanitary", "Impact hard", "USDA-ready"],
  },
  {
    id: "solid",
    num: "04",
    name: "Solid Color",
    dot: "linear-gradient(135deg,#1e1a16,#0c0b09)",
    kicker: "Pigmented resin coat",
    title: "Solid Color",
    image: IMG.solid,
    body: "A clean, monolithic single-color pour with a UV-stable topcoat. Maximum reflectivity, minimum fuss — engineered to carry forklift loads and chemical spills without flinching.",
    specs: [
      ["Thickness", "20–30 mil"],
      ["Cure to walk", "24 hr"],
      ["Best for", "Warehouses · Plants"],
    ],
    tags: ["Heavy load", "Chemical proof", "Fast install"],
  },
];

export const PROCESS = [
  {
    num: "01",
    title: "Grind & Prep",
    body: "Diamond-grinding opens the concrete pore structure so the bond becomes mechanical, not just adhesive.",
  },
  {
    num: "02",
    title: "Repair & Prime",
    body: "Cracks, spalling, and moisture points are corrected before a moisture-blocking primer is applied.",
  },
  {
    num: "03",
    title: "Pour & Design",
    body: "Your chosen system — flake, metallic, quartz, or solid — is hand-poured and worked while the resin is live.",
  },
  {
    num: "04",
    title: "Seal & Cure",
    body: "A UV-stable topcoat locks in the finish and gloss, cured to full chemical resistance in 5–7 days.",
  },
];

export const GALLERY = [
  { label: "Champagne Metallic — Residential Garage", image: IMG.garage, span: true },
  { label: "Gold Vein Metallic — Showroom Floor", image: IMG.showroom },
  { label: "Bronze Quartz — Kitchen Counter", image: IMG.kitchen },
  { label: "Deep Onyx Solid — Warehouse Floor", image: IMG.warehouse },
  { label: "Graphite Flake — Living Room", image: IMG.flake },
  { label: "Liquid Glass Metallic — Studio Pour", image: IMG.metallic, span: true },
];

export const TESTIMONIALS = [
  {
    quote:
      "Our garage looks like a car showroom now. The metallic pour has more depth than I expected from a photo — it moves when you walk across it.",
    who: "Marcus D.",
    role: "Residential, Garage Floor",
  },
  {
    quote:
      "LuxeBond redid our plant floor over a weekend with zero downtime Monday. Forklifts, chemical spills, none of it has touched the finish.",
    who: "Priya S.",
    role: "Facilities Manager, Industrial",
  },
  {
    quote:
      "The epoxy countertops get more compliments than the cabinets. Heat-resistant, seamless, and the color match to our island was exact.",
    who: "The Alvarez Family",
    role: "Residential, Kitchen",
  },
];

export const PROJECT_TYPES = [
  "Residential — Garage",
  "Residential — Home Floor",
  "Countertop",
  "Industrial / Commercial",
];
